import React, { Component, Fragment } from 'react';
import { translate } from '../Services/translation';

class Cart extends Component {
    constructor(props) {
        super(props);
        this.state = {
            editingQuantity: {},
            removingRow: {},
        };
    }

    onQuantityChange(rowSystemId, event) {
        let orderRow = this.props.orderRows.filter(x => x.rowSystemId == rowSystemId)[0];
        let oldQuantity = orderRow.quantity;
        if (event) {

            let packageSize = orderRow.packageSize;
            let maxValue = 999;
            let quantity = event.target.value;

            if (packageSize > 1) {

                let minValue = packageSize;

                if (quantity > oldQuantity) {
                    quantity = oldQuantity + packageSize;
                }
                else {
                    quantity = oldQuantity - packageSize;
                }
                if (quantity < minValue || quantity == "") {
                    quantity = minValue;
                } else if (quantity > maxValue) {
                    quantity = oldQuantity;
                }
            }
            else {
                quantity = quantity.replace("-", "").replace("+", "").replace("e", "").replace(",", "").replace(".", "");
                let minValue = 1;
                if (quantity == "") {
                    quantity = minValue;
                }
                else if (quantity > maxValue) {
                    quantity == maxValue;
                }
                else if (quantity < minValue) {
                    quantity == minValue;
                }
            }
            this.setState(previousState => {
                const newState = {
                    ...previousState,
                    editingQuantity: {
                        ...previousState.editingQuantity,
                        [rowSystemId]: Math.abs(quantity)
                    } // The quantity should be a positive number
                }
                this.props.updateOrderRowQuantity(rowSystemId, newState.editingQuantity[rowSystemId], orderRow.articleNumber)
                    .then(() => this.onQuantityChange(rowSystemId, undefined));
                return newState;
            });
        }
        else {
            let quantity = oldQuantity
            this.setState(previousState => {
                const newState = {
                    ...previousState,
                    editingQuantity: {
                        ...previousState.editingQuantity,
                        [rowSystemId]: Math.abs(quantity)
                    } // The quantity should be a positive number
                }
                return newState;
            });
        }
    }
    
    getStockStatus(id) {
        switch (id) {
            case 2:
                return ["stock-container--order", translate("stock.outofstockwithoutquantity")]
            case 1:
                return ["stock-container--in", translate("product.stockquantitydescription")]
            case 3:
                return ["stock-container--order",translate("stock.orderitem")]
            case 4:
                return ["stock-container--out", translate("stock.unavailable")]
            default:
                return ["stock-container--out", translate("stock.outofstockwithoutquantity")]
        }
    }

    onDeleteRequest(rowSystemId, showDeleteButton) {
        this.setState(previousState => ({
            ...previousState,
            removingRow: {
                ...previousState.removingRow,
                [rowSystemId]: showDeleteButton,
            }
        }));
    }

    render() {
        const { editingQuantity, removingRow } = this.state;
        const productHeaderClass = "columns small-12 medium-6 large-6"; /* = productContentClass */
        const priceHeaderClass = "columns small-3 medium-2 large-2"; /* = priceContentClass */
        const quantityHeaderClass = "columns small-4 medium-2 large-2"; /* = quantityInputClass + quantityActionClass  */
        const totalHeaderClass = "columns small-5 medium-2 large-2"; /* = totalContentClass + totalActionClass  */
        const productContentClass = "small-2 medium-2 large-2" + " checkout-cart__image-container";
        const priceContentClass = "columns small-4 medium-4 large-4 text--right checkout-cart__price-container" + " simple-table__cell--no-break-word";
        const quantityInputClass = "columns small-4 medium-4 large-4 checkout-cart__input-container";
        const quantityActionClass = "columns small-2 medium-1 large-1";
        const totalContentClass = "columns small-4 medium-4 large-4" + " simple-table__cell--no-break-word";
        const totalActionClass = "columns small-3 medium-1 large-1 checkout-cart__remove";

        return <div className="small-12 simple-table">
            {this.props.orderRows && this.props.orderRows.map(order => (
                <div className="row small-unstack no-margin checkout-cart__row" key={order.rowSystemId} id={order.articleNumber}>
                    <div className={productContentClass}>
                        <div className="checkout-cart__image-wrapper">
                            <img className="checkout-cart__image" src={order.image} alt={order.name} />
                        </div>
                    </div>
                    <div className="small-10 medium-9 large-9 checkout-cart__center-container">
                        <div className="checkout-cart__image-info columns small-12 medium-4 large-4">
                            <a href={order.url} className="checkout-cart__image-info--name paragraph-m">{order.name}</a>
                            {order.brandUrl && order.brand &&
                                <a href={order.brandUrl} className="checkout-cart__image-info--brand">{order.brand}</a>
                            }
                            {order.articleNumber &&
                                <div className="span-group">
                                    <span>{translate("variantlist.articlenumber")}: </span>
                                    <span>{order.articleNumber}</span>
                                </div>
                            }
                            {order.color &&
                                <div className="span-group">
                                    <span>{translate("product.color")}: </span>
                                    <span>{order.color}</span>
                                </div>
                            }
                            {order.stockStatus &&
                                <div className="span-group checkout-cart__stock-container">
                                    <div className={this.getStockStatus(order.stockStatus)[0]}></div>
                                    <span>{this.getStockStatus(order.stockStatus)[1]}</span>
                                </div>
                            }
                        </div>
                        <div className="large-8 medium-8 checkout-cart__price-info-container">
                            <div className={priceContentClass}>
                                {order.campaignPrice ? (
                                    <Fragment>
                                        <div className='checkout-cart__campaign-price'>{order.campaignPrice}</div>
                                        <div className='checkout-cart__original-price'> {order.price}</div>
                                    </Fragment>
                                ) : <div className="checkout-cart__price">{order.price}</div>}
                            </div>
                            <div className={quantityInputClass}>
                                {order.isFreeGift ? (<div>{order.quantity}</div>) : (
                                    <input className="checkout-cart__input" type="number" min="1" max={999} id={order.rowSystemId} onKeyDown={(e) => order.packageSize > 1 && e.preventDefault()}
                                        value={editingQuantity[order.rowSystemId] || order.quantity}
                                        onChange={event => this.onQuantityChange(order.rowSystemId, event)} />)
                                }
                            </div>
                            <div className={`checkout-cart__total-price ${totalContentClass}`}>
                                <span>{order.totalPrice}</span>
                                <span>{translate('alternativevariant.excluding')}</span>
                            </div>
                        </div>
                    </div>
                    <div className={totalActionClass}>
                        {!order.isFreeGift && !removingRow[order.rowSystemId] && <a className="far fa-times-circle" onClick={() => this.props.removeOrderRow(order.rowSystemId)} title={translate('general.remove')}></a>}
                    </div>
                    {order.packageSize > 1 &&
                        <div className="checkout-cart__package-information">
                            <span>
                                * {translate('product.packageinfo')} {order.packageSize}
                            </span>
                        </div>
                    }
                </div>
            ))}
            <div className="row small-unstack no-margin checkout-cart__row checkout-cart__total-row">
                <div className="columns checkout__total-row">
                    <div className="small-12">
                        <h5 className="text--right">{translate('checkout.cart.total')}</h5>
                        <div className="checkout__total-container">
                            <h5>{this.props.orderTotal}</h5>
                            <span className="paragraph-xs">{translate('alternativevariant.excluding')}</span>
                        </div>
                    </div>
                    {this.props.paymentCost > 0 &&
                        <div className="checkout__payment-cost-container small-12">
                            <div className="column">{translate("checkout.paymentcost.shopfor")} {this.props.formattedPaymentCostLimit} {translate("checkout.paymentcost.avoid").toLowerCase()} {this.props.formattedPaymentCost}</div>
                        </div>
                    }
                </div>
            </div>
        </div>
    }
}

export default Cart;